/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsTabletBookingInput } from "../../entities/models/TabletBookingInput";
import { z } from "zod/v4";

export const modelsTabletBookingInputSchema = z.object({
    "barber_id": z.optional(z.int()),
"booking_mode": z.optional(z.enum(["parallel", "sequential"])),
"child_barber_id": z.optional(z.int()),
"child_emoji": z.optional(z.string()),
"parent_barber_id": z.optional(z.int()),
"selected_emoji": z.optional(z.string()),
"service_type": z.enum(["adult", "child", "adult_child"])
    }) as unknown as z.ZodType<ModelsTabletBookingInput>